import { Tag } from '@carbon/react';
import { useAtom, useAtomValue } from 'jotai';
import { crmTractFormAtom } from './atoms';

export const LotTags = () => {
  const form = useAtomValue(crmTractFormAtom);
  const [lots, setLots] = useAtom(form.lots);
  return (
    <div>
      {lots.value
        .filter((lot) => lot !== '')
        .map((lot) => (
          <Tag
            key={lot}
            type="blue"
            size="sm"
            filter
            onClose={() => {
              setLots(lots.value.filter((l) => l !== lot));
            }}
          >
            {lot}
          </Tag>
        ))}
    </div>
  );
};
